export default {_name:'grid.form.section.button',module:'Card/Form',view:'Element/Section/AsButton',options:{component:'section'}}